import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
  Paper,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Tabs,
  Tab,
  Menu,
} from "@mui/material";
import {
  orange,
  green,
  blue,
  grey,
  yellow,
} from "@mui/material/colors";
import RefreshIcon from "@mui/icons-material/Refresh";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import QrCodeIcon from "@mui/icons-material/QrCode";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const RegiFormTest = () => {
  const [tabValue, setTabValue] = useState(0);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [formData, setFormData] = useState({
    sort: "",
    pnum: "",
    callsgn: "",
    sumnum: "",
    org: "",
    grade: "",
    name: "",
    rcvnum: "",
  });

  // 샘플 데이터
  const sampleData = [
    { id: 11, location: "서울", name: "청담1동민", status: "대기중", statusColor: green[500] },
    { id: 10, location: "강원", name: "춘천보건소 재난지원 1팀", status: "대기중", statusColor: green[500] },
    { id: 9, location: "울산", name: "00물탱크2", status: "이동중", statusColor: blue[500] },
    { id: 8, location: "광주", name: "00펌프1", status: "집결중", statusColor: grey[500] },
    { id: 7, location: "대전", name: "00펌프2", status: "집결중", statusColor: grey[500] },
    { id: 6, location: "대구", name: "00헬기1", status: "집결중", statusColor: grey[500] },
    { id: 5, location: "부산", name: "00화학2", status: "집결중", statusColor: grey[500] },
  ];

  const handleInputChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const handleSubmit = () => {
    alert("등록 기능은 테스트 페이지에서는 동작하지 않습니다.");
  };

  const handleMenuOpen = (event, rowId) => {
    setMenuAnchor(event.currentTarget);
    setSelectedRowId(rowId);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setSelectedRowId(null);
  };

  const handleEdit = (rowId) => {
    alert(`수정 기능: ID ${rowId} 항목을 수정합니다.`);
    handleMenuClose();
  };

  const handleDelete = (rowId) => {
    if (window.confirm(`ID ${rowId} 항목을 삭제하시겠습니까?`)) {
      alert(`삭제 기능: ID ${rowId} 항목이 삭제되었습니다.`);
    }
    handleMenuClose();
  };

  const headerStyle = {
    backgroundColor: orange[500],
    color: "white",
    padding: "10px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  };

  const formContainerStyle = {
    backgroundColor: "#fafafa",
    padding: "10px 12px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
  };

  const inputRowStyle = {
    display: "flex",
    alignItems: "center",
    marginBottom: "8px",
    gap: "10px",
  };

  const labelStyle = {
    minWidth: "120px",
    fontWeight: "600",
    fontSize: "1.1rem",
    color: "#333",
    flexShrink: 0,
  };

  const requiredLabelStyle = {
    ...labelStyle,
    color: "#d32f2f",
  };

  const optionalLabelStyle = {
    ...labelStyle,
    color: "#1976d2",
  };

  const buttonStyle = {
    backgroundColor: orange[600],
    color: "white",
    padding: "12px 32px",
    fontSize: "1.2rem",
    fontWeight: "600",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    "&:hover": {
      backgroundColor: orange[700],
      boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
    },
  };

  const iconButtonStyle = {
    color: "white",
    backgroundColor: "rgba(255,255,255,0.2)",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.3)",
    },
  };

  return (
    <Box sx={{ width: "100%", backgroundColor: "#f5f5f5" }}>
      {/* 헤더 */}
      <Paper elevation={3} sx={{ width: "100%" }}>
        <Box sx={headerStyle}>
          <IconButton
            sx={{
              color: "white",
              backgroundColor: "rgba(255,255,255,0.2)",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.3)",
              },
            }}
          >
            <ArrowBackIcon sx={{ fontSize: "1.5rem" }} />
          </IconButton>
          <Box sx={{ textAlign: "center", flex: 1 }}>
            <Typography variant="h5" sx={{ fontWeight: "bold", fontSize: "1.5rem", lineHeight: 1.2 }}>
              동원자원 관리
            </Typography>
            <Typography variant="caption" sx={{ fontSize: "0.9rem", opacity: 0.9 }}>
              (test20260122)
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: "8px" }}>
            <IconButton sx={iconButtonStyle} size="small">
              <QrCodeIcon />
            </IconButton>
            <IconButton sx={iconButtonStyle} size="small">
              <RefreshIcon />
            </IconButton>
          </Box>
        </Box>

        {/* 탭 네비게이션 */}
        <Box sx={{ borderBottom: 1, borderColor: "divider", backgroundColor: "#fff" }}>
          <Tabs
            value={tabValue}
            onChange={(e, newValue) => setTabValue(newValue)}
            sx={{
              "& .MuiTab-root": {
                fontSize: "1.1rem",
                fontWeight: "500",
                minHeight: "44px",
                textTransform: "none",
                color: grey[600],
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: orange[50],
                  color: orange[700],
                },
              },
              "& .Mui-selected": {
                color: orange[600],
                fontWeight: "700",
                backgroundColor: orange[50],
              },
              "& .MuiTabs-indicator": {
                height: "3px",
                backgroundColor: orange[600],
              },
            }}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="자원등록" />
            <Tab label="자원현황" />
          </Tabs>
        </Box>

        {/* 탭 내용 */}
        {tabValue === 0 && (
          <Box sx={formContainerStyle}>
            {/* 필수 입력 필드 (빨간색 라벨) */}
            <Box sx={inputRowStyle}>
              <Typography sx={requiredLabelStyle}>자원종류 *</Typography>
              <FormControl fullWidth>
                <Select
                  value={formData.sort}
                  onChange={handleInputChange("sort")}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "6px",
                    fontSize: "1.1rem",
                    height: "40px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#d32f2f",
                      borderWidth: "2px",
                    },
                    "& .MuiSelect-select": {
                      padding: "8px 14px",
                    },
                  }}
                >
                  <MenuItem value="">선택</MenuItem>
                  <MenuItem value="소방펌프">소방펌프</MenuItem>
                  <MenuItem value="소방물탱크">소방물탱크</MenuItem>
                  <MenuItem value="소방화학">소방화학</MenuItem>
                  <MenuItem value="소방험지">소방험지</MenuItem>
                  <MenuItem value="소방구조">소방구조</MenuItem>
                  <MenuItem value="소방구급">소방구급</MenuItem>
                  <MenuItem value="소방헬기">소방헬기</MenuItem>
                  <MenuItem value="소방지휘">소방지휘</MenuItem>
                  <MenuItem value="소방기타차량">소방기타차량</MenuItem>
                  <MenuItem value="소방의소대">소방의소대</MenuItem>
                  <MenuItem value="경찰(인원)">경찰(인원)</MenuItem>
                  <MenuItem value="군(인원)">군(인원)</MenuItem>
                  <MenuItem value="공무원(인원)">공무원(인원)</MenuItem>
                  <MenuItem value="민간인(인원)">민간인(인원)</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <Box sx={inputRowStyle}>
              <Typography sx={requiredLabelStyle}>연락처(대표) *</Typography>
              <TextField
                fullWidth
                placeholder="010-1111-9999"
                value={formData.pnum}
                onChange={handleInputChange("pnum")}
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "6px",
                  "& .MuiOutlinedInput-root": {
                    fontSize: "1.1rem",
                    height: "40px",
                    "& input": {
                      padding: "8px 14px",
                    },
                    "& fieldset": {
                      borderColor: "#d32f2f",
                      borderWidth: "2px",
                    },
                  },
                }}
              />
            </Box>

            <Box sx={inputRowStyle}>
              <Typography sx={requiredLabelStyle}>호출명(팀명) *</Typography>
              <TextField
                fullWidth
                placeholder="00펌프1, 1팀, 지원팀"
                value={formData.callsgn}
                onChange={handleInputChange("callsgn")}
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "6px",
                  "& .MuiOutlinedInput-root": {
                    fontSize: "1.1rem",
                    height: "40px",
                    "& input": {
                      padding: "8px 14px",
                    },
                    "& fieldset": {
                      borderColor: "#d32f2f",
                      borderWidth: "2px",
                    },
                  },
                }}
              />
            </Box>

            <Box sx={inputRowStyle}>
              <Typography sx={requiredLabelStyle}>총인원 *</Typography>
              <TextField
                fullWidth
                type="number"
                placeholder="3"
                value={formData.sumnum}
                onChange={handleInputChange("sumnum")}
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "6px",
                  "& .MuiOutlinedInput-root": {
                    fontSize: "1.1rem",
                    height: "40px",
                    "& input": {
                      padding: "8px 14px",
                    },
                    "& fieldset": {
                      borderColor: "#d32f2f",
                      borderWidth: "2px",
                    },
                  },
                }}
              />
            </Box>

            {/* 선택 입력 필드 (파란색 라벨) */}
            <Box sx={inputRowStyle}>
              <Typography sx={requiredLabelStyle}>소속 *</Typography>
              <FormControl fullWidth>
                <Select
                  value={formData.org}
                  onChange={handleInputChange("org")}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "6px",
                    fontSize: "1.1rem",
                    height: "40px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#d32f2f",
                      borderWidth: "2px",
                    },
                    "& .MuiSelect-select": {
                      padding: "8px 14px",
                    },
                  }}
                >
                  <MenuItem value="">선택</MenuItem>
                  <MenuItem value="중앙구조본부">중앙구조본부</MenuItem>
                  <MenuItem value="서울소방재난본부">서울소방재난본부</MenuItem>
                  <MenuItem value="강원도소방본부">강원도소방본부</MenuItem>
                  <MenuItem value="부산소방본부">부산소방본부</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <Box sx={inputRowStyle}>
              <Typography sx={optionalLabelStyle}>직급</Typography>
              <TextField
                fullWidth
                placeholder="소방위, 경위, 주사..."
                value={formData.grade}
                onChange={handleInputChange("grade")}
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "6px",
                  "& .MuiOutlinedInput-root": {
                    fontSize: "1.1rem",
                    height: "40px",
                    "& input": {
                      padding: "8px 14px",
                    },
                    "& fieldset": {
                      borderColor: "#1976d2",
                      borderWidth: "2px",
                    },
                  },
                }}
              />
            </Box>

            <Box sx={inputRowStyle}>
              <Typography sx={optionalLabelStyle}>이름</Typography>
              <TextField
                fullWidth
                placeholder="홍길동"
                value={formData.name}
                onChange={handleInputChange("name")}
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "6px",
                  "& .MuiOutlinedInput-root": {
                    fontSize: "1.1rem",
                    height: "40px",
                    "& input": {
                      padding: "8px 14px",
                    },
                    "& fieldset": {
                      borderColor: "#1976d2",
                      borderWidth: "2px",
                    },
                  },
                }}
              />
            </Box>

            <Box sx={inputRowStyle}>
              <Typography sx={optionalLabelStyle}>회신번호</Typography>
              <TextField
                fullWidth
                placeholder="010-1111-9999"
                value={formData.rcvnum}
                onChange={handleInputChange("rcvnum")}
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "6px",
                  "& .MuiOutlinedInput-root": {
                    fontSize: "1.1rem",
                    height: "40px",
                    "& input": {
                      padding: "8px 14px",
                    },
                    "& fieldset": {
                      borderColor: "#1976d2",
                      borderWidth: "2px",
                    },
                  },
                }}
              />
            </Box>

            {/* 등록 버튼 */}
            <Box sx={{ display: "flex", justifyContent: "center", marginTop: "12px" }}>
              <Button
                variant="contained"
                onClick={handleSubmit}
                sx={buttonStyle}
              >
                등 록
              </Button>
            </Box>
          </Box>
        )}

        {tabValue === 1 && (
          <Box sx={{ backgroundColor: "#fafafa", minHeight: "400px" }}>
            {/* 자원 목록 테이블 */}
            <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ backgroundColor: green[500] }}>
                <TableCell sx={{ color: "white", fontWeight: "bold", textAlign: "center", fontSize: "1rem", padding: "8px 4px", width: "10%" }}>
                  등록번호
                </TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold", textAlign: "center", fontSize: "1rem", padding: "8px 4px", width: "12%", whiteSpace: "nowrap" }}>
                  소속
                </TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold", textAlign: "center", fontSize: "1rem", padding: "8px 4px", width: "35%" }}>
                  장비명
                </TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold", textAlign: "center", fontSize: "1rem", padding: "8px 4px", width: "18%" }}>
                  상태관리
                </TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold", textAlign: "center", fontSize: "1rem", padding: "8px 4px", width: "25%", minWidth: "120px" }}>
                  관리
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sampleData.map((row) => (
                <TableRow key={row.id} sx={{ "&:hover": { backgroundColor: "#f5f5f5" } }}>
                  <TableCell sx={{ textAlign: "center", fontWeight: "500", fontSize: "0.95rem", padding: "8px 4px" }}>
                    {row.id}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", fontSize: "0.95rem", padding: "8px 4px", whiteSpace: "nowrap" }}>{row.location}</TableCell>
                  <TableCell sx={{ textAlign: "center", fontSize: "0.95rem", padding: "8px 4px" }}>{row.name}</TableCell>
                  <TableCell sx={{ textAlign: "center", padding: "8px 4px" }}>
                    <Chip
                      label={row.status}
                      size="small"
                      sx={{
                        backgroundColor: row.statusColor,
                        color: "white",
                        fontWeight: "600",
                        minWidth: "70px",
                        fontSize: "0.9rem",
                        height: "32px",
                        borderRadius: "4px",
                        padding: "4px 12px",
                      }}
                    />
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", padding: "8px 4px", whiteSpace: "nowrap" }}>
                    <Box sx={{ display: "flex", gap: "4px", justifyContent: "center", flexWrap: "nowrap" }}>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={(e) => handleMenuOpen(e, row.id)}
                        sx={{
                          minWidth: "50px",
                          padding: "8px 12px",
                          backgroundColor: "#e8f5e9",
                          borderColor: green[300],
                          fontSize: "0.85rem",
                          fontWeight: "600",
                          borderRadius: "4px",
                          height: "36px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        수정
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{
                          minWidth: "40px",
                          padding: "8px 12px",
                          fontSize: "0.85rem",
                          fontWeight: "600",
                          borderRadius: "4px",
                          height: "36px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        QR
                      </Button>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
          </Box>
        )}

        {/* 수정/삭제 메뉴 */}
        <Menu
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <MenuItem
            onClick={() => handleEdit(selectedRowId)}
            sx={{
              fontSize: "0.95rem",
              padding: "8px 16px",
              "&:hover": {
                backgroundColor: green[50],
              },
            }}
          >
            수정
          </MenuItem>
          <MenuItem
            onClick={() => handleDelete(selectedRowId)}
            sx={{
              fontSize: "0.95rem",
              padding: "8px 16px",
              color: "#d32f2f",
              "&:hover": {
                backgroundColor: "#ffebee",
              },
            }}
          >
            삭제
          </MenuItem>
        </Menu>
      </Paper>
    </Box>
  );
};

export default RegiFormTest;
